import { Component, Input, Output, EventEmitter } from '@angular/core';
import { dropdownLink } from 'app/models/dropdownLink.interface';

@Component({
  selector: 'header-nav-dropdown',
  templateUrl: './header-nav-dropdown.component.html',
  standalone: false,
})
export class HeaderNavDropdownComponent {
  @Input() dropdownTo: dropdownLink[];
  @Input() type = 'Solutions';
  @Input() menuContent = null;
  @Input() title;
  @Output() closeNavEvent = new EventEmitter<boolean>();
  constructor() {}

  closeNavEventHandler() {
    this.closeNavEvent.emit(true);
  }
}
